import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { RoomRepository } from "@entity/data/repositories/room.repository";
import { inject, injectable } from "inversify";

@injectable()
export class DeleteRoomUseCase {
    constructor(
        @inject(RoomRepository)
        private readonly roomRepository: RoomRepository,
    ) {}

    async execute(costId: number): Promise<boolean> {
        const result = await this.roomRepository.delete(costId);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        return result.isRight();
    }
}
